import { CheckGroupChatMemberRequest, GetGroupChatListRequest } from '~/types';

const chatRoomKey = {
  all: ['chatRoom'] as const,
  getChatList: () => [...chatRoomKey.all, 'list'] as const,
  getGroupChatList: (request: GetGroupChatListRequest) =>
    [...chatRoomKey.all, 'group', request] as const,
  groupChatCheckMember: (request: CheckGroupChatMemberRequest) =>
    [...chatRoomKey.all, 'checkMember', request.chatroom_id] as const,
} as const;

export default chatRoomKey;
